<!--
 * @Descripttion: 
 * @Author: Niu Chenxin
 * @Date: 2021-01-15 13:16:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-02 10:06:06
-->
    <template>
  <div class="hfshareGuide" @touchmove.prevent @mousewheel.prevent>
    <!-- 分享弹窗 -->
    <div class="attent-shade" @touchmove.prevent>
      <div class="share_desc">
        <p class="share-line"><img src="../../../assets/images/baby/line.png" /></p>
        <p>一、先点击“
          <van-icon name="ellipsis" size="25px" /> ”
        </p>
        <p>二、再点击“ <img src="../../../assets/images/baby/share.jpg" /> ”分享至朋友圈 或“ <img class="shareFriend" src="../../../assets/images/baby/send.jpg" /> ”发给朋友</p>
        <div class="btn_close" @click="closeShareVideo">
          <van-icon name="close" />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.hfshareGuide{
    //分享遮罩
    .attent-shade{
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background:rgba(0, 0, 0, 0.6);
        z-index: 999999999;
        // 分享弹窗
        .share_desc{
            font-size:18px;
            font-weight:bold;
            color:@expertFontColor255;
            line-height:28px;
            margin-top: 26px;
            margin-left: 27px;
            p{
                width: 256px;
                img{
                    width:18px;
                    height:18px; 
                }
                .shareFriend {
                  width: 23px;
                  height: 20px;
                }
            }
            .share-line{
                text-align: right;
                width: 306px;
                height: 75px;
                img{
                    width: 135px;
                    height: 75px;
                    display: block;
                    float: right;
                }
            }
            .btn_close{
                width:23px;
                height:23px;
                position: fixed;
                bottom: 106px;
                left:calc(50%);
                .van-icon{
                    font-size: @indexFontSize22;
                }
            }
        }
    }
}
</style>
<script>
export default {
  name: "HFshare",
  data () {
    return {

    }
  },
  mounted () {
  },
  methods: {
    closeShareVideo: function () {
      this.$emit('shareToast', false)
    },
  }
}
</script>